module.exports = __webpack_public_path__ + "img/solid.d1bbdef6.png";